export default __webpack_public_path__ + "static/media/press-14.7572245c.jpg";